import { render, staticRenderFns } from "./BaseBalloon.vue?vue&type=template&id=ba25bfe0"
import script from "./BaseBalloon.vue?vue&type=script&lang=js"
export * from "./BaseBalloon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports